import React  from "react";
import { TableCell, TableCellProps } from "@material-ui/core";
import { ProviderLocation } from "generated/graphql";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import pretty from "Shared/pretty";

export interface LocationsTableCellProps {
  locations: ProviderLocation[];
}

export const LocationsTableCell = ({
  locations,
  ...tableCellProps
}: LocationsTableCellProps & TableCellProps) => {
  const { associatedLocationsCount } = usePartnerConfig();

  return (
    <TableCell {...tableCellProps}>
      {
        locations.length && locations.length !== associatedLocationsCount
          ? locations.map((location: ProviderLocation) => (
            <div key={location.id}>
              {pretty.titleizeWord(location.name || "")}
            </div>
          ))
          : "All"
      }
    </TableCell>
  );
};
